<div [formGroup]="formInputElement">
  <div class="input-container flex-column justify-content-start align-items-start inline-flex">
    <ppg-contact-us-form-label [inputId]="inputId()" [labelText]="labelText()"> </ppg-contact-us-form-label>
    <div class="align-self-stretch flex-column justify-content-start align-items-start flex gap-1">
      <input
        pInputText
        [formControl]="formControl()"
        class="input-border align-self-stretch align-items-center justify-content-start inline-flex bg-white border-round-sm"
        [id]="inputId()"
        [formControl]="formControl()"
        placeholder="{{ inputPlaceholderText() }}" />
      @if (formControl().invalid && showErrors()) {
        @if (formControl().hasError('required')) {
          <small id="invalidFieldMessageSmall" class="validation-error-message">
            {{ getErrorMessage('required') }}
          </small>
        }
        @if (formControl().hasError('pattern')) {
          <small id="patternInvalidFieldMessageSmall" class="validation-error-message">
            {{ getErrorMessage('pattern') }}
          </small>
        }
        @if (formControl().hasError('maxlength')) {
          <small id="maxLengthInvalidFieldMessageSmall" class="validation-error-message">
            {{ getErrorMessage('maxLength') }}
          </small>
        }
      }
    </div>
  </div>
</div>
